import { useTranslation } from 'react-i18next'

import { Card, CardContent, Checkbox, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui'
import type { TVagaPadraoUnidadesVinculadasProps } from '@/features/proposta/interfaces/proposta.type'

export const VagaPadraoUnidadesVinculadas = ({ acessoriosVinculados }: TVagaPadraoUnidadesVinculadasProps) => {
  const { t } = useTranslation('proposta')

  return (
    <>
      <SheetHeader className="box-border max-w-137 gap-2 p-0 pt-4 pb-2">
        <SheetTitle className="mt-8 text-2xl font-normal text-neutral-700 uppercase">
          {t('informacoes_iniciais.cards.vaga_padrao.acessorios_vinculados.titulo')}
        </SheetTitle>
        <SheetDescription className="text-base text-neutral-700">
          {t('informacoes_iniciais.cards.vaga_padrao.acessorios_vinculados.descricao')}
        </SheetDescription>
      </SheetHeader>
      <div className="w-full space-y-4 overflow-auto">
        {acessoriosVinculados?.map((item) => (
          <Card className="mb-4 w-full border text-neutral-800 shadow-sm" key={item.nome}>
            <CardContent className="p-3" data-testid="card-content">
              <h3 className="mb-3 font-normal capitalize">{item.nome.toLowerCase()}</h3>
              <div className="grid gap-4">
                {item.acessorios.map((acessorio) => (
                  <div key={acessorio.idExterno} className="flex items-center space-x-2" data-testid="checkbox">
                    <div className="flex items-center py-2 pl-2">
                      <Checkbox
                        id={acessorio.nome}
                        disabled
                        defaultChecked
                        className="disabled:opacity-100 data-[state=checked]:bg-neutral-400"
                      />
                    </div>
                    <label
                      htmlFor={acessorio.nome}
                      className="font-nunito leading-none font-normal text-neutral-500 peer-disabled:cursor-not-allowed"
                    >
                      {acessorio.nome}
                    </label>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  )
}
